/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import { useEffect } from 'react';
import Header from '../../../../components/Header';
import Sidebar from '../../../../components/Sidebar';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import { Link } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { InputFromUser } from '../../../../components/Input/input';
import { SubmitButton } from '../../../../components/Button';
import {
    ActionCreateDietPlan,
    ActionGetDietPlanByID,
    ActionUpdateDietPlan,
} from '../../../../store/Actions/MasterDataAction';

// Validation Schema
const DietPlanValidationSchema = Yup.object().shape({
    dietName: Yup.string().required('Diet name is required'),
    isActive: Yup.boolean(),
});

const Add_DietPlan = () => {
    const dispatch = useDispatch();
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;
    const updateValue = searchParams.get('update');
    const pageValue = searchParams.get('page') ? searchParams.get('page') : 1;
    const idValue = searchParams.get('id');

    useEffect(() => {
        if (idValue) {
            dispatch(ActionGetDietPlanByID({ Query: `/${idValue}` }));
        }
    }, [pageValue, dispatch, idValue]);

    const { dietPlan } = useSelector(state => state?.MasterData);
    const { userDetails } = useSelector(state => state?.auth);

    return (
        <>
            <Header />
            <Sidebar />
            <>
                <div>
                    <div className="page-wrapper">
                        <div className="content">
                            {/* Page Header */}
                            <div className="page-header">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <ul className="breadcrumb">
                                            <li className="breadcrumb-item">
                                                <Link to="/diet-plan">Diet Plan</Link>
                                            </li>
                                            <li className="breadcrumb-item">
                                                <i className="feather-chevron-right">
                                                    <FeatherIcon icon="chevron-right" />
                                                </i>
                                            </li>
                                            <li className="breadcrumb-item active">
                                                {updateValue ? 'Edit' : 'Add'} Diet Plan
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            {/* /Page Header */}
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="card p-3">
                                        <div className="card-body">
                                            <Formik
                                                enableReinitialize={updateValue}
                                                initialValues={{
                                                    dietName: dietPlan?.dietName || '',
                                                    isActive: dietPlan?.isActive !== undefined ? dietPlan?.isActive : true,
                                                }}
                                                validationSchema={DietPlanValidationSchema}
                                                onSubmit={(values, { setSubmitting, setErrors }) => {
                                                    if (!updateValue) {
                                                        dispatch(
                                                            ActionCreateDietPlan(
                                                                {
                                                                    dietName: values.dietName,
                                                                    isActive: values.isActive,
                                                                },
                                                                Res => {
                                                                    setSubmitting(false);
                                                                    if (Res?.statusCode === 200) {
                                                                        window.location.href = `/diet-plan?page=${pageValue}`;
                                                                    } else if (Res?.statusCode === 400) {
                                                                        setErrors(Res?.data?.errors);
                                                                    } else {
                                                                        window.location.reload();
                                                                    }
                                                                }
                                                            )
                                                        );
                                                    } else {
                                                        dispatch(
                                                            ActionUpdateDietPlan(
                                                                {
                                                                    Query: '/' + idValue,
                                                                    obj: {
                                                                        dietName: values.dietName,
                                                                        isActive: values.isActive,
                                                                    },
                                                                },
                                                                Res => {
                                                                    setSubmitting(false);
                                                                    if (Res?.statusCode === 200) {
                                                                        window.location.href = `/diet-plan?page=${pageValue}`;
                                                                    } else if (Res?.statusCode === 400) {
                                                                        setErrors(Res?.data?.errors);
                                                                    } else {
                                                                        window.location.reload();
                                                                    }
                                                                }
                                                            )
                                                        );
                                                    }
                                                }}
                                            >
                                                {({
                                                    values,
                                                    errors,
                                                    touched,
                                                    handleChange,
                                                    handleBlur,
                                                    handleSubmit,
                                                    setFieldValue,
                                                    isSubmitting,
                                                }) => {
                                                    return (
                                                        <form onSubmit={handleSubmit}>
                                                            <div className="row">
                                                                <div className="col-lg-12">
                                                                    <div className="form-heading">
                                                                        <h4>{updateValue ? 'Edit' : 'Add'} Diet Plan</h4>
                                                                    </div>
                                                                </div>

                                                                <InputFromUser
                                                                    placeholder={'Enter diet plan name'}
                                                                    type="text"
                                                                    name="dietName"
                                                                    onChange={handleChange}
                                                                    FormGroupClassName={'col-xl-6 col-md-12'}
                                                                    LabelClassName={'col-form-label'}
                                                                    onBlur={handleBlur}
                                                                    value={values.dietName}
                                                                    label="Diet Name *"
                                                                    error={errors?.dietName}
                                                                    touched={touched.dietName}
                                                                />
                                                                <InputFromUser
                                                                    type="singleSelect"
                                                                    name="isActive"
                                                                    onChange={v => {
                                                                        // Extract value if it's an object, otherwise use as-is
                                                                        const value = typeof v === 'object' && v !== null ? v.value : v;
                                                                        setFieldValue('isActive', value);
                                                                    }}
                                                                    FormGroupClassName={'col-xl-6 col-md-12'}
                                                                    LabelClassName={'col-form-label'}
                                                                    onBlur={handleBlur}
                                                                    value={values.isActive}
                                                                    label="Status"
                                                                    options={[
                                                                        { label: 'Active', value: true },
                                                                        { label: 'Inactive', value: false },
                                                                    ]}
                                                                    error={errors?.isActive}
                                                                    touched={touched.isActive}
                                                                />

                                                                <div className="col-12 mt-4">
                                                                    <div className="doctor-submit text-end">
                                                                        <SubmitButton
                                                                            htmlType="button"
                                                                            onClick={handleSubmit}
                                                                            className="btn btn-primary submit-form me-2"
                                                                            loading={isSubmitting}
                                                                        >
                                                                            {updateValue ? 'Update' : 'Submit'}
                                                                        </SubmitButton>
                                                                        <Link
                                                                            to={`/diet-plan?page=${pageValue}`}
                                                                            className="btn btn-primary cancel-form"
                                                                        >
                                                                            Cancel
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </form>
                                                    );
                                                }}
                                            </Formik>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        </>
    );
};

export default Add_DietPlan;
